import { render, staticRenderFns } from "./Buy.vue?vue&type=template&id=7a2f0bcb&scoped=true&"
import script from "./Buy.vue?vue&type=script&lang=js&"
export * from "./Buy.vue?vue&type=script&lang=js&"
import style0 from "./Buy.vue?vue&type=style&index=0&id=7a2f0bcb&lang=scss&scoped=true&"
import style1 from "./Buy.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2f0bcb",
  null
  
)

export default component.exports